export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/linkedin_profiles.43c436c.svg";